import { createSlice } from '@reduxjs/toolkit'
import type { PayloadAction } from '@reduxjs/toolkit'
import { RootState } from '../index'
import { KarteTracking, CurrentUrl, TrackingState } from '@/types/tracking'

const initialState: TrackingState = {
  karteTrackingItems: {
    title: '',
    companyName: '',
    url: '',
    actionBtns: [],
  },
}

export const trackingSlice = createSlice({
  name: 'tracking',
  initialState,
  reducers: {
    setKarteTrackingItem: (
      state,
      action: PayloadAction<{
        entryKarteTracking: KarteTracking
        currentUrl: CurrentUrl
      }>,
    ) => {
      const { entryKarteTracking, currentUrl } = action.payload
      state.karteTrackingItems = {
        title: entryKarteTracking.title || currentUrl.name || '',
        companyName: entryKarteTracking.companyName || '',
        url: currentUrl.url || '',
        actionBtns: entryKarteTracking.actionBtns || [],
      }
    },
  },
})

export const { setKarteTrackingItem } = trackingSlice.actions
export const selectKarteTrackingItems = (state: RootState) => state.tracking.karteTrackingItems
export default trackingSlice.reducer
